import { Stack, styled } from '@mui/material';

export const StyledStack = styled(Stack)`
  padding: 10px;
  background-color: whitesmoke;
  border-radius: 5px;
  margin-bottom: 6px;
  cursor: pointer;
`;
